// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { TaxDrag_DefaultsFragment } from '../taxDrag/TaxDrag.generated';
import { gql } from '@apollo/client';
import { TaxDrag_DefaultsFragmentDoc } from '../taxDrag/TaxDrag.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GrowthProfileModal_EntityFragment = { __typename?: 'Entity', id: string, stage: Types.EntityStage, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } };

export type GrowthProfileModal_ProposalFragment = { __typename?: 'Proposal', id: string, displayName: string };

export type GrowthProfileModal_GrowthProfileOverrideFragment = { __typename?: 'GrowthProfileOverride', id: string, kind: Types.GrowthProfileOverrideKind, customGrowthRate?: Percent | null, entityFutureValuationValue?: CurrencyUSD | null, entityFutureValuationYear?: number | null, entityGrowthAfterFutureValuation?: Percent | null, entityGrowthBeforeFutureValuation?: Percent | null, entity?: (
    { __typename?: 'Entity' }
    & GrowthProfileModal_EntityFragment
  ) | null, proposal?: (
    { __typename?: 'Proposal' }
    & GrowthProfileModal_ProposalFragment
  ) | null, assetClass?: (
    { __typename?: 'AssetClass' }
    & GrowthProfileModal_AssetClassFragment
  ) | null };

export type GrowthProfileModal_GrowthProfileFragment = { __typename?: 'GrowthProfile', id: string, displayName: string, isDefault: boolean, growthType: Types.GrowthProfileGrowthType, exemptionGrowthRate: Percent, assetGrowthReturn?: Percent | null, growthProfileOverrides: { __typename?: 'GrowthProfileOverrideConnection', edges?: Array<{ __typename?: 'GrowthProfileOverrideEdge', node?: (
        { __typename?: 'GrowthProfileOverride' }
        & GrowthProfileModal_GrowthProfileOverrideFragment
      ) | null } | null> | null }, taxDragConfig?: { __typename?: 'TaxDragConfig', id: string, calculationMethod: Types.TaxDragConfigCalculationMethod, taxDragPercentage: Percent, federalIncomeTaxRate?: Percent | null, federalLongTermCapitalGainsRate?: Percent | null, stateIncomeTaxRate?: Percent | null, stateLongTermCapitalGainsRate?: Percent | null, niitEnabled: boolean, ordinaryIncomeReturnPercentage?: Percent | null, longTermCapitalGainReturnPercentage?: Percent | null, qualifiedDividendReturnPercentage?: Percent | null, taxFreeIncomeReturnPercentage?: Percent | null } | null, incomeTaxPaymentConfig?: { __typename?: 'IncomeTaxPaymentConfig', id: string, grantorPaymentMethod: Types.IncomeTaxPaymentConfigGrantorPaymentMethod, nonGrantorPaymentMethod: Types.IncomeTaxPaymentConfigNonGrantorPaymentMethod, customPayerOrder?: Array<string> | null } | null, taxDragOverrides: { __typename?: 'TaxDragOverrideConnection', edges?: Array<{ __typename?: 'TaxDragOverrideEdge', node?: { __typename?: 'TaxDragOverride', id: string, calculationMethod: Types.TaxDragOverrideCalculationMethod, taxDragPercentage: Percent, federalIncomeTaxRate?: Percent | null, federalLongTermCapitalGainsRate?: Percent | null, stateIncomeTaxRate?: Percent | null, stateLongTermCapitalGainsRate?: Percent | null, niitEnabled: boolean, ordinaryIncomeReturnPercentage?: Percent | null, longTermCapitalGainReturnPercentage?: Percent | null, qualifiedDividendReturnPercentage?: Percent | null, taxFreeIncomeReturnPercentage?: Percent | null, entity?: { __typename?: 'Entity', id: string } | null } | null } | null> | null } };

export type GrowthProfileModal_AssetClassFragment = { __typename?: 'AssetClass', id: string, displayName: string, growthRate?: Percent | null, taxDragRate: Percent };

export type GrowthProfileModalQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
  growthProfileId: Types.Scalars['ID']['input'];
  hasExistingGrowthProfile: Types.Scalars['Boolean']['input'];
}>;


export type GrowthProfileModalQuery = { __typename?: 'Query', incomeTaxDragDefaults: (
    { __typename?: 'IncomeTaxDragDefaults' }
    & TaxDrag_DefaultsFragment
  ), assetClasses: { __typename?: 'AssetClassConnection', edges?: Array<{ __typename?: 'AssetClassEdge', node?: (
        { __typename?: 'AssetClass' }
        & GrowthProfileModal_AssetClassFragment
      ) | null } | null> | null }, growthProfiles?: { __typename?: 'GrowthProfileConnection', edges?: Array<{ __typename?: 'GrowthProfileEdge', node?: (
        { __typename?: 'GrowthProfile' }
        & GrowthProfileModal_GrowthProfileFragment
      ) | null } | null> | null }, households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: { __typename?: 'Household', id: string, possiblePrimaryClients: Array<{ __typename?: 'ClientProfile', id: string, isPrimary: boolean, address?: { __typename?: 'Address', id: string, stateCode: string } | null }> } | null } | null> | null } };

export const Operations = {
  Query: {
    GrowthProfileModal: 'GrowthProfileModal' as const
  },
  Fragment: {
    GrowthProfileModal_Entity: 'GrowthProfileModal_Entity' as const,
    GrowthProfileModal_Proposal: 'GrowthProfileModal_Proposal' as const,
    GrowthProfileModal_GrowthProfileOverride: 'GrowthProfileModal_GrowthProfileOverride' as const,
    GrowthProfileModal_GrowthProfile: 'GrowthProfileModal_GrowthProfile' as const,
    GrowthProfileModal_AssetClass: 'GrowthProfileModal_AssetClass' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const GrowthProfileModal_EntityFragmentDoc = gql`
    fragment GrowthProfileModal_Entity on Entity {
  id
  stage
  subtype {
    id
    displayName
  }
}
    `;
export const GrowthProfileModal_ProposalFragmentDoc = gql`
    fragment GrowthProfileModal_Proposal on Proposal {
  id
  displayName
}
    `;
export const GrowthProfileModal_AssetClassFragmentDoc = gql`
    fragment GrowthProfileModal_AssetClass on AssetClass {
  id
  displayName
  growthRate
  taxDragRate
}
    `;
export const GrowthProfileModal_GrowthProfileOverrideFragmentDoc = gql`
    fragment GrowthProfileModal_GrowthProfileOverride on GrowthProfileOverride {
  id
  kind
  entity {
    ...GrowthProfileModal_Entity
  }
  proposal {
    ...GrowthProfileModal_Proposal
  }
  customGrowthRate
  entityFutureValuationValue
  entityFutureValuationYear
  entityGrowthAfterFutureValuation
  entityGrowthBeforeFutureValuation
  assetClass {
    ...GrowthProfileModal_AssetClass
  }
}
    ${GrowthProfileModal_EntityFragmentDoc}
${GrowthProfileModal_ProposalFragmentDoc}
${GrowthProfileModal_AssetClassFragmentDoc}`;
export const GrowthProfileModal_GrowthProfileFragmentDoc = gql`
    fragment GrowthProfileModal_GrowthProfile on GrowthProfile {
  id
  displayName
  isDefault
  growthType
  exemptionGrowthRate
  assetGrowthReturn
  growthProfileOverrides {
    edges {
      node {
        ...GrowthProfileModal_GrowthProfileOverride
      }
    }
  }
  taxDragConfig {
    id
    calculationMethod
    taxDragPercentage
    federalIncomeTaxRate
    federalLongTermCapitalGainsRate
    stateIncomeTaxRate
    stateLongTermCapitalGainsRate
    niitEnabled
    ordinaryIncomeReturnPercentage
    longTermCapitalGainReturnPercentage
    qualifiedDividendReturnPercentage
    taxFreeIncomeReturnPercentage
  }
  incomeTaxPaymentConfig {
    id
    grantorPaymentMethod
    nonGrantorPaymentMethod
    customPayerOrder
  }
  taxDragOverrides {
    edges {
      node {
        id
        calculationMethod
        taxDragPercentage
        federalIncomeTaxRate
        federalLongTermCapitalGainsRate
        stateIncomeTaxRate
        stateLongTermCapitalGainsRate
        niitEnabled
        ordinaryIncomeReturnPercentage
        longTermCapitalGainReturnPercentage
        qualifiedDividendReturnPercentage
        taxFreeIncomeReturnPercentage
        entity {
          id
        }
      }
    }
  }
}
    ${GrowthProfileModal_GrowthProfileOverrideFragmentDoc}`;
export const GrowthProfileModalDocument = gql`
    query GrowthProfileModal($householdId: ID!, $growthProfileId: ID!, $hasExistingGrowthProfile: Boolean!) {
  incomeTaxDragDefaults {
    ...TaxDrag_Defaults
  }
  assetClasses {
    edges {
      node {
        ...GrowthProfileModal_AssetClass
      }
    }
  }
  growthProfiles(where: {id: $growthProfileId}, first: 1) @include(if: $hasExistingGrowthProfile) {
    edges {
      node {
        ...GrowthProfileModal_GrowthProfile
      }
    }
  }
  households(where: {id: $householdId}, first: 1) {
    edges {
      node {
        id
        possiblePrimaryClients {
          id
          isPrimary
          address {
            id
            stateCode
          }
        }
      }
    }
  }
}
    ${TaxDrag_DefaultsFragmentDoc}
${GrowthProfileModal_AssetClassFragmentDoc}
${GrowthProfileModal_GrowthProfileFragmentDoc}`;

/**
 * __useGrowthProfileModalQuery__
 *
 * To run a query within a React component, call `useGrowthProfileModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrowthProfileModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrowthProfileModalQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *      growthProfileId: // value for 'growthProfileId'
 *      hasExistingGrowthProfile: // value for 'hasExistingGrowthProfile'
 *   },
 * });
 */
export function useGrowthProfileModalQuery(baseOptions: Apollo.QueryHookOptions<GrowthProfileModalQuery, GrowthProfileModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GrowthProfileModalQuery, GrowthProfileModalQueryVariables>(GrowthProfileModalDocument, withFetchPolicyContext(options));
      }
export function useGrowthProfileModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GrowthProfileModalQuery, GrowthProfileModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GrowthProfileModalQuery, GrowthProfileModalQueryVariables>(GrowthProfileModalDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGrowthProfileModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GrowthProfileModalQuery, GrowthProfileModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GrowthProfileModalQuery, GrowthProfileModalQueryVariables>(GrowthProfileModalDocument, withFetchPolicyContext(options));
        }
export type GrowthProfileModalQueryHookResult = ReturnType<typeof useGrowthProfileModalQuery>;
export type GrowthProfileModalLazyQueryHookResult = ReturnType<typeof useGrowthProfileModalLazyQuery>;
export type GrowthProfileModalSuspenseQueryHookResult = ReturnType<typeof useGrowthProfileModalSuspenseQuery>;
export type GrowthProfileModalQueryResult = Apollo.QueryResult<GrowthProfileModalQuery, GrowthProfileModalQueryVariables>;